import { render, staticRenderFns } from "./RecursosHumanos.vue?vue&type=template&id=5618c9e4&scoped=true"
import script from "./RecursosHumanos.vue?vue&type=script&lang=js"
export * from "./RecursosHumanos.vue?vue&type=script&lang=js"
import style0 from "./RecursosHumanos.vue?vue&type=style&index=0&id=5618c9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5618c9e4",
  null
  
)

export default component.exports